import { withNativeProps } from "../../utils/with-native-props";
import React from 'react';
export var CnSliderItem = function (props) {
    return withNativeProps(props, React.createElement("div", { className: "cn-ui-m-slider-item", onClick: props.onClick }, props.children));
};
